var render = function (_h,_vm) {var _c=_vm._c;return _c('svg',{staticClass:"eco-icon",class:[].concat(_vm.data.staticClass, _vm.data.class),attrs:{"height":"1.3em","width":"1.3em","viewBox":"0 0 32 32","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M12 1 L26 16 L12 31 L8 27 L18 16 L8 5 z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }